<div class="documentarchives">
    <div class="container">
        <div class="crew-header">
            <h4>Collaterals and Reports</h4>
            <button mat-raised-button color="primary" class="button ml-auto remove" (click)="navigateToUploadPage()">
                <mat-icon>upload</mat-icon>
                Upload Document
            </button>
        </div>
    </div>

    <div>
        <form [formGroup]="collateralsForm" (ngSubmit)="onSubmit()">
            <div class="documentform">
                <div class="p-2">
                    <mat-form-field appearance="outline" color="primary">
                        <mat-label>Client</mat-label>
                        <mat-select formControlName="client" placeholder="Client">
                            <mat-option *ngFor="let item of clients" [value]="item.id">{{ item.dname }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="collateralsForm.get('client').hasError('required')">*Client is
                            required</mat-error>
                    </mat-form-field>
                </div>
                <div class="p-2">
                    <mat-form-field appearance="outline" color="primary">
                        <mat-label>To</mat-label>
                        <mat-select formControlName="to" placeholder="To">
                            <mat-option *ngFor="let item of dropdownOptions.to" [value]="item">{{ item }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="collateralsForm.get('to')?.hasError('required')">*To is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="p-2">
                    <mat-form-field appearance="outline" color="primary">
                        <mat-label>Doc Type</mat-label>
                        <mat-select formControlName="docType" placeholder="Doc Type">
                            <mat-option *ngFor="let item of dropdownOptions.docType" [value]="item">{{ item
                                }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="collateralsForm.get('docType')?.hasError('required')">*Doc Type is
                            required</mat-error>
                    </mat-form-field>
                </div>

                <div class="p-2" *ngIf="collateralsForm.get('docType')?.value !== 'Collaterals'">
                    <mat-form-field appearance="outline" color="primary">
                        <mat-label>Report Type</mat-label>
                        <mat-select formControlName="reportType" placeholder="Report Type">
                            <mat-option *ngFor="let item of dropdownOptions.reportType" [value]="item">{{ item
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="p-2" *ngIf="collateralsForm.get('docType')?.value !== 'Collaterals'">
                    <mat-form-field appearance="outline" color="primary">
                        <mat-label>Year</mat-label>
                        <mat-select formControlName="year" placeholder="Year">
                            <mat-option *ngFor="let item of dropdownOptions.year" [value]="item">{{ item }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="apply">
                    <button mat-raised-button color="primary" class="button remove" type="submit">Apply</button>
                </div>
            </div>
        </form>

        <div class="container">
            <div class="crew-header" *ngIf="success && showDeleteButton">
                <button mat-raised-button color="primary" class="button remove" (click)="deleteSelected()">
                    <mat-icon>delete</mat-icon>
                    Delete Selected
                </button>
            </div>
        </div>

        <div *ngIf="showCollateralsData" class="collaterals-section">
            <div class="container">
                <div class="crew-header">
                    <div class="overflow-x-scroll">
                        <div class="crew-tabel">
                            <div class="tabel-head">
                                <div *ngFor="let header of tableHeaders">
                                    <span *ngIf="header === 'Sr.No'">
                                        <span style="display: inline-flex; align-items: left; gap: 5px;">
                                            <input type="checkbox" [(ngModel)]="selectAll"
                                                (change)="toggleSelectAll()" />
                                            <span>{{ header }}</span>
                                        </span>
                                    </span>
                                    <span *ngIf="header !== 'Sr.No'">{{ header }}</span>
                                </div>
                            </div>
                            <div class="tabel-container thin-scroll mg-scroll">
                                <div class="toper">
                                    <div class="tabel-content">
                                        <div class="tabel-body"
                                            *ngFor="let file of documentarchives.file; let i = index">
                                            <div class="body-ele">
                                                <input type="checkbox" [checked]="isSelected(i)"
                                                    (change)="toggleSelection(i)" />
                                                <span>{{ file.sr_no }}</span>
                                            </div>
                                            <div class="body-ele"><span>{{ file.file_name }}</span></div>
                                            <div class="body-ele"><span>{{ file.file_type }}</span></div>
                                            <div class="body-ele"><span>{{ file.upload_Details }}</span></div>
                                            <div class="body-ele">
                                                <span>{{ file.file_size }}</span>
                                                <span>
                                                    <i>
                                                        <mat-icon (click)="downloadFile(file.url)">
                                                            {{ file.download }}
                                                        </mat-icon>
                                                    </i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-template #noData>
                                <div class="tabel-con">
                                    <img src="../../../../assets/noData.svg" width="170" alt="">
                                    <span class="mt-4"> No Activity Found</span>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="showReportsData" class="reports-section">
            <div class="container">
                <div class="crew-header">
                    <div class="overflow-x-scroll">
                        <div class="crew-tabel">
                            <div class="tabel-head">
                                <div *ngFor="let header of tableHeaders">
                                    <span *ngIf="header === 'Sr.No'">
                                        <span style="display: inline-flex; align-items: left; gap: 5px;">
                                            <input type="checkbox" [(ngModel)]="selectAll"
                                                (change)="toggleSelectAll()" />
                                            <span>{{ header }}</span>
                                        </span>
                                    </span>
                                    <span *ngIf="header !== 'Sr.No'">{{ header }}</span>
                                </div>
                            </div>
                            <div class="tabel-container thin-scroll mg-scroll">
                                <div class="toper">
                                    <div class="tabel-content">
                                        <div class="tabel-body"
                                            *ngFor="let file of documentarchives.file; let i = index">
                                            <div class="body-ele">
                                                <input type="checkbox" [checked]="isSelected(i)"
                                                    (change)="toggleSelection(i)" />
                                                <span>{{ file.sr_no }}</span>
                                            </div>
                                            <div class="body-ele"><span>{{ file.report_type }}</span></div>
                                            <div class="body-ele"><span>{{ file.report_period }}</span></div>
                                            <div class="body-ele"><span>{{ file.file_name }}</span></div>
                                            <div class="body-ele"><span>{{ file.file_type }}</span></div>
                                            <div class="body-ele"><span>{{ file.upload_Details }}</span></div>
                                            <div class="body-ele">
                                                <span>{{ file.file_size }}</span>
                                                <span>
                                                    <i>
                                                        <mat-icon (click)="downloadFile(file.url)">
                                                            {{ file.download }}
                                                        </mat-icon>
                                                    </i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-template #noData>
                                <div class="tabel-con">
                                    <img src="../../../../assets/noData.svg" width="170" alt="">
                                    <span class="mt-4"> No Activity Found</span>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #loading>
    <div class="center loading">
        <span class="d">.</span><span class="d d-2">.</span><span class="d d-3">.</span>
    </div>
</ng-template>